<template>
  <div>
    <el-color-picker
      v-model="selectedColor"
      :predefine="predefineColors"
      @change="confirmColor"
    />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import tinycolor from 'tinycolor2'

export default {
  props: {
    mess: String,
  },
  data() {
    return {
      selectedColor: 'rgb(255, 128, 192)',
      predefineColors: [
        'rgb(255, 128, 128)', 'rgb(255, 255, 128)', 'rgb(128, 255, 128)',
        'rgb(0, 255, 128)', 'rgb(128, 255, 255)', 'rgb(0, 128, 255)',
        'rgb(255, 128, 192)', 'rgb(255, 0, 0)', 'rgb(255, 255, 0)',
        'rgb(128, 255, 0)', 'rgb(0, 255, 64)', 'rgb(0, 255, 255)',
        'rgb(0, 128, 192)', 'rgb(128, 128, 192)', 'rgb(255, 0, 255)',
        'rgb(128, 64, 64)', 'rgb(255, 128, 64)', 'rgb(0, 255, 0)',
        'rgb(0, 128, 128)', 'rgb(0, 64, 128)', 'rgb(128, 128, 255)',
        'rgb(128, 0, 64)', 'rgb(255, 0, 128)', 'rgb(128, 0, 0)',
        'rgb(255, 128, 0)', 'rgb(0, 128, 0)', 'rgb(0, 128, 64)',
        'rgb(0, 0, 255)', 'rgb(0, 0, 160)', 'rgb(128, 0, 128)',
        'rgb(128, 0, 255)', 'rgb(255, 255, 255)', 'rgb(64, 0, 255)',
        'rgb(192, 192, 192)', 'rgb(64, 128, 128)', 'rgb(128, 128, 128)',
        'rgb(128, 128, 64)', 'rgb(128, 128, 0)', 'rgb(0, 0, 0)',
      ],
      visible: true,
    }
  },
  methods: {
    ...mapMutations(['setSelectedChange']),

    confirmColor() {
      if (!this.selectedColor || !this.mess) {
        this.setSelectedChange(!this.visible)
        return
      }
      const rgbStr = tinycolor(this.selectedColor).toRgbString()
      const rgb = rgbStr.slice(rgbStr.indexOf('(') + 1, -1).split(',')
      const id = this.mess

      this.$store.state.meshList.forEach(item => {
        if (item.model_id === id) {
          item.material.color.r = rgb[0] !== 0 ? rgb[0] / 255 : 0
          item.material.color.g = rgb[1] !== 0 ? rgb[1] / 255 : 0
          item.material.color.b = rgb[2] !== 0 ? rgb[2] / 255 : 0
          const label = document.getElementById(id)
          if (label) {
            label.style.border = `2px solid ${this.selectedColor}`
            if (label.children[2]) {
              label.children[2].style.background = this.selectedColor
            }
          }
        }
      })
      this.setSelectedChange(!this.visible)
    },
  },
  mounted() {
    const dropdown = document.getElementsByClassName('el-color-dropdown')[0]
    const cancelBtn = document.getElementsByClassName('el-color-dropdown__link-btn')[0]
    if (cancelBtn) cancelBtn.children[0].innerText = '取消'
    if (dropdown) dropdown.style.display = 'block'
  },
}
</script>
<style lang="scss">
@import url('./ColorSelector.scss');
</style>
